import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'billRate',
    standalone: false
})
export class BillRatePipe implements PipeTransform {

  transform(value: number): number {
    // This is the more precise way to calculate for $ value.
    return isNaN(value) ? 0 : parseFloat((Math.ceil(value * 1.37 * 100) / 100).toFixed(2));
  }
}
